// uiarc: arc-motion-tokens (https://uiarc.dev/r/arc-motion-tokens.json)
// Hareket token'ları: süreler saniye, easing'ler cubic-bezier dizisi (motion/react için).
// CSS karşılığı `src/index.css` (`--duration-*`, `--ease-*`); değerler aynı kalmalı, motion.test.ts denetler.
// Bileşen animasyonu yalnız bu token'larla yapılır (docs/DESIGN.md §1); `prefers-reduced-motion` için
// bileşen `useReducedMotion()` (motion/react) okur ve `reducedTransition` ya da düz solmaya düşer.
import type { Transition } from 'motion/react'

export type Bezier = [number, number, number, number]

export const motionTokens = {
  duration: { instant: 0.12, fast: 0.16, exit: 0.18, standard: 0.24, considered: 0.48 },
  ease: {
    enter: [0.16, 1, 0.3, 1] as Bezier,
    exit: [0.7, 0, 0.84, 0] as Bezier,
    standard: [0.22, 1, 0.36, 1] as Bezier,
    /** Ekranda zaten hareket eden öğeler için. */
    inOut: [0.65, 0, 0.35, 1] as Bezier,
  },
  spring: {
    responsive: { type: 'spring', stiffness: 520, damping: 44 },
    gentle: { type: 'spring', stiffness: 340, damping: 34 },
    /** Basma, anahtar, başparmak, küçük göstergeler. Hızlı oturur, taşmaz. */
    snappy: { type: 'spring', visualDuration: 0.26, bounce: 0 },
    /** Paneller, yükseklik değişimi, yerleşim kayması. Kritik sönümlü. */
    smooth: { type: 'spring', visualDuration: 0.4, bounce: 0 },
    /** Şekil/genişlik geçişleri ve paylaşılan yerleşim vurgusu. Taşma yok. */
    morph: { type: 'spring', visualDuration: 0.42, bounce: 0 },
  },
  /** Kademe adımları (sn). Toplam kademe yaklaşık 0,4 sn'yi geçmesin. */
  stagger: { char: 0.016, word: 0.04, line: 0.08, item: 0.035 },
  /** Metin/içerik çapraz geçişinde bulanıklık yarıçapı (px). Küçük ve kısa tut. */
  blur: { subtle: 2, soft: 4, text: 8 },
} as const satisfies {
  duration: Record<string, number>
  ease: Record<string, Bezier>
  spring: Record<string, Transition>
  stagger: Record<string, number>
  blur: Record<string, number>
}

/** `prefers-reduced-motion` altında kullanılacak tek geçiş: kısa düz solma, hareket yok. */
export const reducedTransition: Transition = { duration: motionTokens.duration.instant }
